import React from "react"
import Head from "next/head"
import { useCheck } from "../../hooks/useUser"
import { DefaultSiteName } from "../../libs/vars/system"

type Props = {
  isLoading?: boolean
  isError?: Error | string
}

export default function LayoutLoadingAuthRequired({
  isLoading,
  isError,
}: Props) {
  useCheck({ isNeedRedirect: true })

  let content = null

  if (isLoading) {
    content = <p>Загрузка...</p>
  }

  if (isError) {
    content = <p>Ошибка: {JSON.stringify(isError)}</p>
  }

  return (
    <React.Fragment>
      <Head>
        <title>{DefaultSiteName}</title>
        <meta charSet="utf-8" />
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
      </Head>

      <div className="mx-auto max-w-3xl px-6 py-2 text-center">{content}</div>
    </React.Fragment>
  )
}
